import { DataAiCertificationsData } from "./DataAiCertificationsData";
import "./ProgramsContent.css";

export default function DataAICertifications() {
  return (
    // <a
    //   href="https://www.databricks.com/learn/training/certification#certifications" 
    //   target="_blank"
    //   rel="noopener noreferrer"
    //   className="full_section_link"
    // >
      <div className="data_ai_bg_section">
        <div>
          <h3 className="header_section">Data & AI Certifications</h3>
        </div>

        <div className="databricks_box">
          <div>
            <div className="databricks_first_section">
              <img
                src={process.env.PUBLIC_URL + DataAiCertificationsData[0].icon}
                alt="icon"
                className="pg_icons"
              />
              <h4 className="databricks_first_section_hd">
                {DataAiCertificationsData[0].title}
              </h4>
            </div>
            <div className="databricks_content">
              {DataAiCertificationsData[0].items.map((item, i) => (
                <div key={i} className="cert_item">
                  <a
                    href={item.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="cert_link"
                    onClick={(e) => e.stopPropagation()}
                    style={{ whiteSpace: "pre-line" }}
                  >
                    {item.name}
                  </a>
                  {i !== DataAiCertificationsData[0].items.length - 1 && (
                    <span className="right-border"></span>
                  )}
                </div>
              ))}
            </div>
          </div>
          <div className="data_ai_second_section">
            {DataAiCertificationsData.slice(1, 3).map((cert, idx) => (
              <div key={idx}>
                <div className="databricks_first_section">
                  <img
                    src={process.env.PUBLIC_URL + cert.icon}
                    alt="icon"
                    className="pg_icons"
                  />
                  <h4 className="databricks_first_section_hd">{cert.title}</h4>
                </div>
                <div className="neo_box">
                  {cert.items.map((item, i) => (
                    <div key={i} className="cert_item">
                      <a
                        href={item.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="cert_link"
                        onClick={(e) => e.stopPropagation()}
                      >
                        {item.name}
                      </a>
                      {i !== cert.items.length - 1 && (
                        <span className="right-border"></span>
                      )}
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
          <div className="data_ai_second_section">
            {DataAiCertificationsData.slice(3, 5).map((cert, idx) => (
              <div key={idx}>
                <div className="databricks_first_section">
                  <img
                    src={process.env.PUBLIC_URL + cert.icon}
                    alt="icon"
                    className="pg_icons"
                  />
                  <h4 className="databricks_first_section_hd">{cert.title}</h4>
                </div>
                <div className="neo_box">
                  {cert.items.map((item, i) => (
                    <div key={i} className="cert_item">
                      <a
                        href={item.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="cert_link"
                        onClick={(e) => e.stopPropagation()}
                      >
                        {item.name}
                      </a>
                      {i !== cert.items.length - 1 && (
                        <span className="right-border"></span>
                      )}
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    // </a>
  );
}